import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { CommonService } from '../../common/services/common.service';
import { environment } from '../../../../environments/environment';
import { HttpProvider } from '../../common/http/http-provider.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(private commonService: CommonService, private httpBaseService: HttpProvider) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers && request.headers.has("showloader") && request.headers.get("showloader") === "1")
      this.commonService.HideShowLoader(true);
    if (request.headers && request.headers.has("apiRequest") && request.headers.get("apiRequest") === "1") {
      request = request.clone({
        // setHeaders: {
        //   Authorization: `Bearer ${this.commonService.bearerToken}`
        // },

        url: environment.apiUrl + request.url
      });
    }
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (request.headers && request.headers.has("showloader") && request.headers.get("showloader") === "1")
          this.commonService.HideShowLoader(false);
      }
    },
      (err: any) => {
        if (request.headers && request.headers.has("showloader") && request.headers.get("showloader") === "1")
          this.commonService.HideShowLoader(false);
      }));;
  }
}
